import React, { Component } from 'react'//
import MenuButton from 'components/layout/MenuButton'
import './Header.scss'
import { Link } from 'react-router'

export function Header({ left: Left = Back, right: Right = MenuButton, title: Title, ...props }) {
  Title = typeof Title == 'string' ? defaultTitle(Title) : Title

  return (
    <div className="menu">
      {/* Left && (<div className="left vcenter"><Left {...props}/></div>)*/}
      {/* Title && (<div className="center vcenter"><Title/></div>)*/}
      { /*Right && <Right/>*/}
      <MenuButton path={props.router.location.pathname} router={props.router} prefixUrlChilder={props.prefixUrlChilder} menuChilderUrl={props.menuChilderUrl}/>{/**弹出的导航菜单栏目*/}
    </div>
  )
}


function defaultTitle(title) {
  return (props) => (<div className="top-title">{title}</div> )
}

function Back({ router }) {
  return (<img className="back" onClick={() => router.goBack()} src={require('./images/back.png')} alt="后退"/>)
}



// WEBPACK FOOTER //
// ./components/layout/Header.js